<template>
    <div id="edit-software-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Edit Software</h1>
                <template v-if="loaded">
                    <SoftwareForm :formData="softwareObject" submitText="Update" @formSubmitted="updateSoftware" />
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import SoftwareForm from '@/components/forms/SoftwareForm.vue'
const apiBase = process.env.VUE_APP_API_BASE
import axios from 'axios'

export default {
    name: 'BrandsEdit',
    components: {
        SoftwareForm
    },
    data: function () {
        return {
            softwareId: this.$route.params.id,
            softwareObject: null,
            loaded: false
        }
    },
    created() {
        axios.get(apiBase + '/softwares/' + this.softwareId)
            .then(response => {
                this.softwareObject = response.data.data
                this.loaded = true
            })
            .catch(error => {
                alert('Could not load software!')
                console.log(error)
            })
    },
    methods: {
        updateSoftware(data) {
            axios.put(apiBase + '/softwares/' + this.softwareId, data)
                .then(response => {
                    console.log(response)
                    alert('Software updated successfully')
                    this.$router.push('/softwares')
                })
                .catch(error => {
                    alert('Error occurred!')
                    console.log(error)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
